export default "__VITE_ASSET__DIpJsa1o__"